import common from './common';
import error from './error';
import file from './file';
import header from './header';
import passport from './passport';
import steps from './steps';
import maps from './maps';

export default {
  ...steps,
  ...header,
  ...passport,
  ...error,
  ...common,
  ...file,
  ...maps,
};
